import { Inbox } from '../models';
import { Resource } from './resource';

export class InboxStatus extends Resource {
  resourcePath = 'v1/inbox';

  async getStatus(): Promise<Inbox> {
    const response = await this.api.get(this.path('status'));
    return Inbox.fromJson(response.data.data);
  }
}
